import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  padding: 0 30px;
`;
export const Content = styled.div`
  height: 64px;
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
  nav {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
`;
